import { useState, useEffect } from 'react';
import { collection, onSnapshot, orderBy, query } from 'firebase/firestore';
import { genderNeutral } from '../utils/genderNeutral';
import { db } from '../firebase';

export function useBodyAreas() {
  const [bodyAreas, setBodyAreas] = useState([]);

  const FIREBASE_COLLECTION = process.env.REACT_APP_FIREBASE_COLLECTION;
  const collectionRef = collection(db, FIREBASE_COLLECTION);
  const q = query(collectionRef, orderBy('index'));

  useEffect(() => {
    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        let fetchedData = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        // This filter is no longer needed but is kept just in case
        //   const filtered = fetchedData.filter(
        //     (elem) => !elem.id.includes('upgrades') && elem.id !== 'bundles'
        //   );
        // Remove all areas with female first
        fetchedData.forEach(
          (doc) =>
            (doc.areas = doc.areas.filter(
              (area) => !area.id.includes('female')
            ))
        );
        // Then Gender Neutral the male ones
        fetchedData.forEach((doc) =>
          doc.areas.forEach((area) => {
            area.id = genderNeutral(area.id);
            area.name = genderNeutral(area.name);
          })
        );
        fetchedData.forEach((doc) =>
          doc.areas.sort((a, b) => a.name.localeCompare(b.name))
        );

        fetchedData.forEach((doc) => {
          const areas = [...doc.areas];
          doc.areas = areas.filter((area) => area.display);
        });

        fetchedData.forEach((doc) =>
          doc.areas.sort((a, b) => a.index - b.index)
        ); // if there's an index

        setBodyAreas(fetchedData);
      },
      (error) => {
        console.error(error);
      }
    );
    // Stop listening to changes
    return unsubscribe;
  }, []);
  return bodyAreas;
}
export default useBodyAreas;

//   filtered.push({
//     id: 'full_body',
//     name: 'Full Body',
//     index: filtered.length,
//     areas: [
//       {
//         id: 'full_body',
//         name: 'Full Body',
//         index: 0,
//         size: 'BODY',
//       },
//     ],
//   });

// import { doc, updateDoc } from "firebase/firestore"
// Outside the useffect
// const addNewPropToAreas = async (parent) => {
//   let areasArr = [...parent.areas]
//   areasArr.forEach(area => {
//     area.size = sizes[area.name]
//   })
//   console.log(areasArr)
//   const docRef = doc(db, FIREBASE_COLLECTION, parent.id)
//   updateDoc(docRef, { areas: areasArr })
// }

// Inside the useEffect
// addNewPropToAreas(fetchedData[6])
